import { PlaneLabel, PlaneRadiusVector } from '../mathematic-plane';

import { PlaneProfileLine } from './plane-profile-line';

export class PlaneProfileLabel extends PlaneLabel {
    constructor(
        public parentLine: PlaneProfileLine,
        public text: string,
        public position: PlaneRadiusVector,
        public angle: number,
        public isAngleLabel: boolean
    ) {
        super(text, position, angle, isAngleLabel);
    }
}
